"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CFilterGenerationFieldRangeOption = void 0;
var CFilterGenerationFieldRangeOption;
(function (CFilterGenerationFieldRangeOption) {
    CFilterGenerationFieldRangeOption["max"] = "max";
    CFilterGenerationFieldRangeOption["min"] = "min";
})(CFilterGenerationFieldRangeOption = exports.CFilterGenerationFieldRangeOption || (exports.CFilterGenerationFieldRangeOption = {}));
//# sourceMappingURL=ConfigurableFilters.types.js.map